<template>
  <div v-if="$companyConfiguration.cascading.isEnabled()">
    <page-heading
      heading="Планирование и каскадирование"
    >
      <span slot="help"></span>
      <span slot="right"></span>
    </page-heading>


    <ElementsTreeComponent
      :from-element-id="fromElementId"
      :from-parent-id="fromParentId"
    ></ElementsTreeComponent>
  </div>
</template>

<script>
import ElementsTreeComponent from "@/modules/cascading/components/ElementsTree/ElementsTreeComponent.vue";
import PageHeading from "@/components/PageHeading.vue";

export default {
  components: { PageHeading, ElementsTreeComponent},

  beforeMount() {
    this.fromElementId = this.$route.params.element_id ? parseInt(this.$route.params.element_id) : null;
    this.fromParentId = this.$route.params.parent_id ? parseInt(this.$route.params.parent_id) : null;
  },
  watch: {
    '$route.params.element_id': function(newVal) {
      this.fromElementId = newVal;
    },
    '$route.params.parent_id': function(newVal) {
      this.fromParentId = newVal;
    },
  },
  data () {
    return {
      fromElementId: null,
      fromParentId: null,
    }
  },

  methods: {}
}
</script>

<style lang="scss">
@import "@/assets/css/project-variables";


</style>